import React, { useState } from "react"
import { Bell, HelpCircle, MoreVertical, LogOut, User } from "lucide-react"
import { Link } from "react-router-dom"

export function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  return (
    <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-2">
        <Link to="/" className="flex items-center">
          <img src="/mentorsity-logo.png" className="h-8 mr-2" alt="Mentorsity Logo" />
        </Link>

        <div className="flex items-center space-x-3">
          <button className="text-gray-500 hover:text-gray-700"><Bell className="h-5 w-5" /></button>
          <button className="text-gray-500 hover:text-gray-700"><HelpCircle className="h-5 w-5" /></button>

          <div className="relative">
            <button onClick={() => setDropdownOpen(!dropdownOpen)} className="text-gray-500 hover:text-gray-700">
              <MoreVertical className="h-5 w-5" />
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-white border rounded shadow-lg py-2 z-50">
                <Link to="/profile" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  <User className="w-4 h-4 mr-2" /> Profile
                </Link>
                <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  onClick={() => alert("Logging out...")}>
                  <LogOut className="w-4 h-4 mr-2" /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}
